module.exports = __webpack_public_path__ + "img/ent_hero_image.d951e6c4.jpg";